import { Location } from "history";
import { matchPath } from "react-router-dom";

export function checkIfActive(
  location: Location,
  urls: Array<string | undefined>,
  exact = false,
) {
  return urls.some(
    (url) =>
      url &&
      matchPath(location.pathname, { path: url, exact: url === "/" || exact }),
  );
}

export function withDashboardRootAlias(urls: Array<string | undefined>) {
  const normalizedUrls = urls.filter((url): url is string => Boolean(url));

  return normalizedUrls.includes("/dashboard/insights")
    ? ["/", ...normalizedUrls]
    : normalizedUrls;
}
